import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Header from './Header'
import TopStores from './TopStores'
import TopBrands from './TopBrands'
import TopModels from './TopModels'
import PopularSize from './PopularSize'
import AveragePrice from './AveragePrice'
import CustomerColleague from './CustomerColleague'
import ReturningNew from './ReturningNew'
import MostPopularChannel from './MostPopularChannel'
import LeastPopularChannel from './LeastPopularChannel'
import OverallInteractions from './OverallInteractions'
import WorstSize from './WorstSize'
import WorstStores from './WorstStores'
import { HeaderContainer, TopContainer, MiddleContainer, BottomContainer } from './Dashboard.styles'

import { Column, Padding } from '../../..'
import { statistics as statisticsProps } from '../../../../types'
import { withSize } from '../../../utils'

class Dashboard extends PureComponent {
    static propTypes = {
        data: PropTypes.shape(statisticsProps),
        isClearFiltersVisible: PropTypes.bool,
        isScreenLarge: PropTypes.bool,
        labelsDateFilter: PropTypes.arrayOf(PropTypes.string),
        loading: PropTypes.number,
        onChangeDateFilter: PropTypes.func,
        onClearFilters: PropTypes.func,
        onStoreChange: PropTypes.func,
        onStoreInputChange: PropTypes.func,
        selectedDateFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        selectedStore: PropTypes.string,
        stores: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string,
                value: PropTypes.string,
            })
        ),
        storeInputValue: PropTypes.string,
        valuesDateFilter: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        isMobile: PropTypes.bool,
    }

    static defaultProps = {
        data: {},
        isClearFiltersVisible: false,
        isScreenLarge: true,
        labelsDateFilter: [],
        loading: null,
        onChangeDateFilter: () => null,
        onClearFilters: () => null,
        onStoreChange: () => null,
        onStoreInputChange: () => null,
        selectedDateFilter: null,
        selectedStore: null,
        stores: [],
        storeInputValue: '',
        valuesDateFilter: [],
        isMobile: false,
    }

    constructor(props) {
        super(props)

        this.state = {
            displayWorstSize: false,
            displayWorstStores: false,
            displayTooltip: false,
        }

        this.onClickSizeHeader = this.onClickSizeHeader.bind(this)
        this.onClickStoresHeader = this.onClickStoresHeader.bind(this)
    }

    onClickSizeHeader() {
        const { displayWorstSize } = this.state
        this.setState({ displayWorstSize: !displayWorstSize })
    }

    onClickStoresHeader() {
        const { displayWorstStores } = this.state
        this.setState({ displayWorstStores: !displayWorstStores })
    }

    onChangeTooltipVisibility = () => {
        const { displayTooltip } = this.state
        this.setState({ displayTooltip: !displayTooltip })
    }

    renderAsPC = () => {
        const {
            data: {
                activity: { data: activityData, labels: activityLabels },
                averagePrice,
                bottomChannels,
                bottomScreenSize,
                prevAveragePrice,
                topChannels,
                topScreenSizes,
                topBrands,
                topModels,
                topStores,
                userTypeCounts,
                worstStores,
            },
            isClearFiltersVisible,
            isScreenLarge,
            labelsDateFilter,
            loading,
            onChangeDateFilter,
            onClearFilters,
            onStoreChange,
            onStoreInputChange,
            selectedDateFilter,
            selectedStore,
            stores,
            storeInputValue,
            valuesDateFilter,
            isMobile,
        } = this.props
        const { displayWorstSize, displayWorstStores, displayTooltip } = this.state
        const userCounts = userTypeCounts.length ? userTypeCounts[0] : {}
        const { returnVisitor, newVisitor, colleague, customer } = userCounts
        const totalVisitors = returnVisitor + newVisitor
        const totalUsers = colleague + customer
        const returnvisitorsPerc = returnVisitor / totalVisitors || 0
        const colleaguePerc = colleague / totalUsers || 0

        return (
            <Padding size="md" fullHeight>
                <HeaderContainer bottom size="md">
                    <Header
                        isClearFiltersVisible={isClearFiltersVisible}
                        labelsDateFilter={labelsDateFilter}
                        onChangeDateFilter={onChangeDateFilter}
                        onClearFilters={onClearFilters}
                        onStoreChange={onStoreChange}
                        onStoreInputChange={onStoreInputChange}
                        selectedDateFilter={selectedDateFilter}
                        selectedStore={selectedStore}
                        stores={stores}
                        storeInputValue={storeInputValue}
                        valuesDateFilter={valuesDateFilter}
                        displayTooltip={displayTooltip}
                        onChangeTooltipVisibility={this.onChangeTooltipVisibility}
                    />
                </HeaderContainer>
                {/* Top Containers */}
                <TopContainer bottom size="md">
                    <Column width={isMobile ? '100%' : '20%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            {displayWorstStores && (
                                <WorstStores isEmpty={!worstStores.length} loading={loading} onClickHeader={this.onClickStoresHeader} stores={worstStores} />
                            )}
                            {!displayWorstStores && (
                                <TopStores isEmpty={!topStores.length} loading={loading} onClickHeader={this.onClickStoresHeader} stores={topStores} />
                            )}
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '20%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            <TopBrands brands={topBrands} isEmpty={!topBrands.length} loading={loading} selectedStore={selectedStore} />
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '60%'}>
                        <TopModels
                            isEmpty={!topModels.length}
                            loading={loading}
                            models={topModels.sort(({ unique_visitors: a }, { unique_visitors: b }) => a - b)}
                        />
                    </Column>
                </TopContainer>
                {/* Middle Containers */}
                <MiddleContainer bottom size="md">
                    <Column width={isMobile ? '100%' : '16.66666%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            {displayWorstSize && (
                                <WorstSize
                                    isEmpty={!bottomScreenSize.length}
                                    loading={loading}
                                    onClickHeader={this.onClickSizeHeader}
                                    size={(bottomScreenSize[0] || {}).screensize}
                                />
                            )}
                            {!displayWorstSize && (
                                <PopularSize
                                    isEmpty={!topScreenSizes.length}
                                    loading={loading}
                                    onClickHeader={this.onClickSizeHeader}
                                    size={(topScreenSizes[0] || {}).screensize}
                                />
                            )}
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '16.66666%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            <AveragePrice isEmpty={!averagePrice} loading={loading} price={averagePrice} delta={averagePrice - prevAveragePrice} />
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '16.66666%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            <CustomerColleague
                                isEmpty={!returnVisitor && !newVisitor}
                                loading={loading}
                                value={returnvisitorsPerc}
                                withLavels={isScreenLarge}
                            />
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '16.66666%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            <ReturningNew isEmpty={!colleague && !customer} loading={loading} value={colleaguePerc} withLavels={isScreenLarge} />
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '16.66666%'}>
                        <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                            <MostPopularChannel isEmpty={!topChannels.length} loading={loading} channel={(topChannels[0] || {}).channel} />
                        </Padding>
                    </Column>
                    <Column width={isMobile ? '100%' : '16.66666%'}>
                        <LeastPopularChannel isEmpty={!bottomChannels.length} loading={loading} channel={(bottomChannels[0] || {}).channel} />
                    </Column>
                </MiddleContainer>
                {/* Bottom Containers */}
                <BottomContainer bottom size="md">
                    <Column width="100%">
                        <OverallInteractions data={activityData} isEmpty={!activityData.length} labels={activityLabels} loading={loading} />
                    </Column>
                </BottomContainer>
            </Padding>
        )
    }

    renderAsMobile = () => {
        const {
            data: {
                activity: { data: activityData, labels: activityLabels },
                averagePrice,
                bottomChannels,
                bottomScreenSize,
                prevAveragePrice,
                topChannels,
                topScreenSizes,
                topBrands,
                topModels,
                topStores,
                userTypeCounts,
                worstStores,
            },
            isClearFiltersVisible,
            isScreenLarge,
            labelsDateFilter,
            loading,
            onChangeDateFilter,
            onClearFilters,
            onStoreChange,
            onStoreInputChange,
            selectedDateFilter,
            selectedStore,
            stores,
            storeInputValue,
            valuesDateFilter,
            isMobile,
        } = this.props
        const { displayWorstSize, displayWorstStores, displayTooltip } = this.state
        const userCounts = userTypeCounts.length ? userTypeCounts[0] : {}
        const { returnVisitor, newVisitor, colleague, customer } = userCounts
        const totalVisitors = returnVisitor + newVisitor
        const totalUsers = colleague + customer
        const returnvisitorsPerc = returnVisitor / totalVisitors || 0
        const colleaguePerc = colleague / totalUsers || 0

        return (
            <Padding size="md" fullHeight>
                <HeaderContainer bottom size="md">
                    <Header
                        isClearFiltersVisible={isClearFiltersVisible}
                        labelsDateFilter={labelsDateFilter}
                        onChangeDateFilter={onChangeDateFilter}
                        onClearFilters={onClearFilters}
                        onStoreChange={onStoreChange}
                        onStoreInputChange={onStoreInputChange}
                        selectedDateFilter={selectedDateFilter}
                        selectedStore={selectedStore}
                        stores={stores}
                        storeInputValue={storeInputValue}
                        valuesDateFilter={valuesDateFilter}
                        displayTooltip={displayTooltip}
                        onChangeTooltipVisibility={this.onChangeTooltipVisibility}
                    />
                </HeaderContainer>
                <Column width={isMobile ? '100%' : '20%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        {displayWorstStores && (
                            <WorstStores isEmpty={!worstStores.length} loading={loading} onClickHeader={this.onClickStoresHeader} stores={worstStores} />
                        )}
                        {!displayWorstStores && (
                            <TopStores isEmpty={!topStores.length} loading={loading} onClickHeader={this.onClickStoresHeader} stores={topStores} />
                        )}
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '20%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        <TopBrands brands={topBrands} isEmpty={!topBrands.length} loading={loading} selectedStore={selectedStore} />
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '60%'}>
                    <TopModels
                        isEmpty={!topModels.length}
                        loading={loading}
                        models={topModels.sort(({ unique_visitors: a }, { unique_visitors: b }) => a - b)}
                    />
                </Column>
                <Column width={isMobile ? '100%' : '16.66666%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        {displayWorstSize && (
                            <WorstSize
                                isEmpty={!bottomScreenSize.length}
                                loading={loading}
                                onClickHeader={this.onClickSizeHeader}
                                size={(bottomScreenSize[0] || {}).screensize}
                            />
                        )}
                        {!displayWorstSize && (
                            <PopularSize
                                isEmpty={!topScreenSizes.length}
                                loading={loading}
                                onClickHeader={this.onClickSizeHeader}
                                size={(topScreenSizes[0] || {}).screensize}
                            />
                        )}
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '16.66666%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        <AveragePrice isEmpty={!averagePrice} loading={loading} price={averagePrice} delta={averagePrice - prevAveragePrice} />
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '16.66666%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        <CustomerColleague isEmpty={!returnVisitor && !newVisitor} loading={loading} value={returnvisitorsPerc} withLavels={isScreenLarge} />
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '16.66666%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        <ReturningNew isEmpty={!colleague && !customer} loading={loading} value={colleaguePerc} withLavels={isScreenLarge} />
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '16.66666%'}>
                    <Padding right={!isMobile} noPadding={isMobile} size="sm" fullHeight>
                        <MostPopularChannel isEmpty={!topChannels.length} loading={loading} channel={(topChannels[0] || {}).channel} />
                    </Padding>
                </Column>
                <Column width={isMobile ? '100%' : '16.66666%'}>
                    <LeastPopularChannel isEmpty={!bottomChannels.length} loading={loading} channel={(bottomChannels[0] || {}).channel} />
                </Column>
                <Column width="100%">
                    <OverallInteractions data={activityData} isEmpty={!activityData.length} labels={activityLabels} loading={loading} />
                </Column>
            </Padding>
        )
    }

    render() {
        const { isMobile } = this.props

        return isMobile ? this.renderAsMobile() : this.renderAsPC()
    }
}

export default withSize(Dashboard)
